enum WorkEligibilityType {
  USCitizen = 'USCitizen',
  NotUSCitizen = 'NotUSCitizen',
  Resident = 'Resident',
  AlienAuthorizedToWork = 'AlienAuthorizedToWork',
}

export default WorkEligibilityType;
